import { Routes } from '@angular/router';
import {ComingSoonComponent} from "./pages/coming-soon/coming-soon.component";
import {NotFoundComponent} from "./pages/not-found/not-found.component";

export const routes: Routes = [
  { path: '', component: ComingSoonComponent },
  { path: 'not-found', component: NotFoundComponent },
  { path: '**', redirectTo: 'not-found', pathMatch: 'full' }
];
